import { render } from "./JieXiaoView.vue?vue&type=template&id=4f6acb36&ts=true"
import script from "./JieXiaoView.vue?vue&type=script&lang=ts"
export * from "./JieXiaoView.vue?vue&type=script&lang=ts"

import "./JieXiaoView.vue?vue&type=style&index=0&id=4f6acb36&lang=scss"

import exportComponent from "C:\\vue项目\\fushuliang2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__